module.exports = {"TXTWCL_Featured":{"id":"TXTWCL_Featured","defaultMessage":"Featured"}}